var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9790_19103)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3658 10.8226L4.9998 17L4.9998 20L7.9998 20L7.9998 18L9.94158 18L9.94158 16H11.9998L14.1842 13.641L11.3658 10.8226Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7427 13.2279C9.39957 10.8848 9.39957 7.08579 11.7427 4.74264C14.0859 2.39949 17.8848 2.39949 20.228 4.74264C22.5711 7.08579 22.5711 10.8848 20.228 13.2279C17.8848 15.5711 14.0859 15.5711 11.7427 13.2279ZM16.0607 9.18198C16.6465 9.76777 17.5963 9.76777 18.1821 9.18198C18.7678 8.59619 18.7678 7.64645 18.1821 7.06066C17.5963 6.47487 16.6465 6.47487 16.0607 7.06066C15.4749 7.64645 15.4749 8.59619 16.0607 9.18198Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9790_19103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoy);
export default __webpack_public_path__ + "static/media/decoy.bbe893be4eea59203a9e3a4325336b05.svg";
export { ForwardRef as ReactComponent };